import shared from "./base.module";
import { editor as api } from "../../../api/user.api";
import defaultUser, { accessUserRoles} from "@lab/meta/user";
import { OrganisationUser } from "@lab/types/users";

const state = {
	...shared.state,
	listings: [],
	listingContacts: [],
	organisation: {
		id: 0,
		name: null
	}
};

const getters = {
	...shared.getters,
	listings: (state) => state.listings,
	listingContacts: (state) => state.listingContacts,
	organisation: (state) => {
		const { id, name } = state.organisation;
		return id ? { id, name } : null;
	},
	roles: (_) => accessUserRoles,
	user: (state, getters) => {
		return {
			...state.user,
			config: getters.config,
			listings: getters.listings,
			listingContacts: getters.listingContacts,
			organisation: getters.organisation
		} as OrganisationUser;
	}
};

const actions = {
	...shared.actions,
	async prepare({ commit }, user) {
		const { id } = user;
		commit("SET_USER", user);

		const organisation = await api.organisation.get(id);
		commit("SET_ORGANISATION", {
			id: organisation.id,
			name: organisation.name
		});

		const listings = (await api.listings.get(id)) || [];
		commit(
			"SET_LISTINGS",
			listings.map((listing) => ({
				id: listing.id,
				name: `${listing.title} (${listing.postcode})`
			}))
		);

		const listingContacts = await api.listingContacts.get(id);
		commit(
			"SET_LISTING_CONTACTS",
			listingContacts.map((contact) => ({
				name: `${contact.listingtitle} (${contact.listingpostcode})`,
				...contact
			}))
		);

		const config = await api.config.get(id);
		commit("SET_CONFIG", config);
	}
};

const mutations = {
	...shared.mutations,
	SET_LISTINGS(state: any, listings) {
		state.listings = listings;
	},
	SET_LISTING_CONTACTS(state, listings) {
		state.listingContacts = listings;
	},
	SET_ORGANISATION(state: any, organisation) {
		state.organisation = organisation;
	},
	RESET_USER(state: any) {
		state.user = { ...defaultUser };
		state.listings = [];
		state.organisation = {
			id: 0,
			name: null
		};
		state.config = {
			calloutrequests: true,
			meetingsenabled: true,
			sitetourrequests: true
		};
	},
	updateListings(state, listings) {
		state.listings = listings;
	},
	updateOrganisation(state, organisation) {
		state.organisation = organisation;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
